import { useTranslation } from '@lt/localization';
import React from 'react';
import styled, { css } from 'styled-components';
import PriceChecker from '../PriceChecker';
import TopbarStepper from './components/TopbarStepper';
import { TEST_ID_TOPBAR_OPEN_SUMMARY_BTN } from './constants';
import type { Step } from './types';
import { pushTopBarOpened } from './analitics';

type Props = {
  currentStep: string;
  steps: Step[];
  onClickStep: (newStep: string) => void;
  priceChanged: boolean;
  changeDirection?: 'up' | 'down';
  isPriceChangedSignificantly: boolean;
  oldPrice?: number;
  currentPrice?: number;
  lastUpdated: number;
  timeout: number;
  fetching: boolean;
  instantConfirm: boolean;
  onOpenSummary: () => void;
};

const Topbar = (props: Props) => {
  const {
    currentStep,
    steps,
    onClickStep,
    priceChanged,
    changeDirection,
    isPriceChangedSignificantly,
    oldPrice,
    currentPrice,
    lastUpdated,
    timeout,
    fetching,
    instantConfirm,
    onOpenSummary,
  } = props;

  const { t } = useTranslation();

  const onClick = () => {
    onOpenSummary();
    pushTopBarOpened();
  };

  const showPriceInfo = currentStep !== steps[0]?.id;

  return (
    <Wrapper $showPriceInfo={showPriceInfo}>
      <TopbarStepper
        currentStep={currentStep}
        onClickStep={onClickStep}
        steps={steps}
      />
      {showPriceInfo && (
        <>
          <PriceChecker
            priceChanged={priceChanged}
            changeDirection={changeDirection}
            isPriceChangedSignificantly={isPriceChangedSignificantly}
            oldPrice={oldPrice}
            currentPrice={currentPrice}
            lastUpdated={lastUpdated}
            timeout={timeout}
            fetching={fetching}
            instantConfirm={instantConfirm}
          />
          <OpenSummaryButton
            onClick={onClick}
            data-testid={TEST_ID_TOPBAR_OPEN_SUMMARY_BTN}
          >
            {t('checkout.billInfo.orderInfo')}
          </OpenSummaryButton>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $showPriceInfo?: boolean }>`
  padding: 8px;
  background-color: white;
  border-radius: 0 0 8px 8px;

  transition: 0.15s all ease-in-out;

  ${(props) =>
    props.$showPriceInfo
      ? css`
          > :first-child {
            margin-bottom: 8px;
          }

          box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1),
            0 1px 2px -1px rgb(0 0 0 / 0.1);
        `
      : css`
          background-color: transparent;
        `}
`;

const OpenSummaryButton = styled.div`
  font-size: 14px;
  color: #007aff;
  cursor: pointer;

  &:active {
    color: #179fe3;
  }
`;

export default Topbar;
